import { render, staticRenderFns } from "./intentionApproval.vue?vue&type=template&id=6d7bcfd6&scoped=true&"
import script from "./intentionApproval.vue?vue&type=script&lang=js&"
export * from "./intentionApproval.vue?vue&type=script&lang=js&"
import style0 from "./intentionApproval.vue?vue&type=style&index=0&id=6d7bcfd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7bcfd6",
  null
  
)

export default component.exports